import { CopyOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, InputNumber, Row, Table, Tabs } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { idNhomKPI, layTenTienDoKPI, phongBan, trangThaiKPI, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { arrayCommon, dateCommon } from '../../helpers/common';
import { ChiTietKPICaNhan, NhomKPICaNhan } from '../../models/kpi/KPICaNhan';
import { saoChepChiTietKPI } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { renderSpanCongViec } from './kpiHelper';

const ViewChiTietKPITab = ({ idNhanVien, tieuDe, source, trangThai, thoiGian, isLDPhong, idDonVi, idBanDieuHanh, hasLDPhuTrach, idLDPhuTrach, disabled, valid, showError, onChange }:
    {
        idNhanVien: number, tieuDe: string, source: NhomKPICaNhan, trangThai: number, thoiGian: Dayjs, isLDPhong: boolean, idDonVi: number, idBanDieuHanh: number, idLDPhuTrach: number, hasLDPhuTrach: boolean, disabled: boolean, valid: boolean, showError: boolean, onChange: (data: NhomKPICaNhan, showErr: boolean) => void
    }) => {

    const dispatch = useDispatch();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([
        Links.KPI.ChiTietKPI,
        Links.KPI.ThemKPI,
        Links.KPI.LanhDaoPhongDuyet,
        Links.KPI.LanhDaoPhuTrachDuyet,
        Links.KPI.LanhDaoDonViDuyet,
        Links.KPI.TongHopKPI]
    );
    const [listIdCopy, setListIdCopy] = useState<Array<number>>([]);
    const listIdChiTiet = (source.chiTiet || []).map(x => x.id);
    const soDongDaChon = listIdChiTiet.filter(id => listIdCopy.includes(id)).length;
    const saoChepCol =
    {
        title: <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
            <Button
                title="Sao chép chi tiết KPI"
                className="hrm-btn hrm-btn-warning"
                icon={<CopyOutlined rev="" />}
                onClick={() => {
                    eventCopyChiTietKPI();
                }}
            >
            </Button>
            {/* tick = chọn tất cả, bỏ tick = bỏ chọn tất cả, chọn 1 phần thì hiển thị nửa chọn */}
            <Checkbox
                title={soDongDaChon === listIdChiTiet.length ? "Bỏ chọn tất cả" : "Chọn tất cả"}
                checked={listIdChiTiet.length > 0 && soDongDaChon === listIdChiTiet.length}
                indeterminate={soDongDaChon > 0 && soDongDaChon < listIdChiTiet.length}
                disabled={listIdChiTiet.length === 0}
                onChange={(e) => setListIdCopy(e.target.checked ? listIdChiTiet : [])}
            />
        </div>,
        key: "chon",
        dataIndex: "",
        width: "1%",
        render: (value: any, record: ChiTietKPICaNhan, index: number) => {
            return (
                <div className='text-center' key={record.id}>
                    <Checkbox
                        data-index={record?.id}
                        checked={listIdCopy.includes(record?.id)}
                        onChange={(e) => {
                            var isChecked = e.target.checked;
                            var tempItems = [...listIdCopy];
                            var isExists = arrayCommon.isExisted(listIdCopy, record.id);
                            if (isChecked && !isExists) {
                                tempItems.push(record.id);
                            }
                            if (!isChecked && isExists) {
                                var index = tempItems.indexOf(record.id);
                                if (index > -1) {
                                    tempItems.splice(index, 1);
                                }
                            }
                            setListIdCopy(tempItems);
                        }}
                    />
                </div>
            )
        },
    };

    const dynamicColumns = ((user.idNhanVien !== idNhanVien && disabled) && ((menu[Links.KPI.LanhDaoPhongDuyet] && idDonVi == user.idDonVi)
        || (menu[Links.KPI.LanhDaoPhuTrachDuyet] && isLDPhong && idLDPhuTrach == user.idNhanVien)
        || (menu[Links.KPI.LanhDaoDonViDuyet] && (idBanDieuHanh > 0 || (isLDPhong && idDonVi == phongBan.keToan)))))
        ? [saoChepCol] : [];
    const tableColumns: ColumnsType<ChiTietKPICaNhan> = [
        {
            title: "STT",
            width: "8px",
            key: "thutu",
            dataIndex: "thutu",
            className: "text-center",
            render: (value, record, index) => {
                if (record.isTieuDe === 1) {
                    return <label>{record.thuTuStr}</label>;
                }
                return record.thuTuStr;
            }
        },
        {
            title: "Nội dung",
            key: "tenCongViec",
            dataIndex: "tenCongViec",
            className: "",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 9 : 1,
            }),
            render: (value, record, index) => {
                return renderSpanCongViec(record, trangThai);
            }
        },
        {
            title: "Thời gian giao",
            key: "thoiGianGiao",
            dataIndex: "thoiGianGiao",
            className: "text-center",
            width: "145px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return dateCommon.formatDate(record.thoiGianGiao, "dd/MM/yyyy");
            }
        },
        {
            title: "TG Yêu cầu",
            key: "thoiGianYeuCauHoanThanh",
            dataIndex: "thoiGianYeuCauHoanThanh",
            className: "text-center",
            width: "145px",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return dateCommon.formatDate(record.thoiGianYeuCauHoanThanh, "dd/MM/yyyy");
            }
        },
        {
            title: "Chất lượng CV",
            key: "chatLuong",
            dataIndex: "chatLuong",
            className: "text-center",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            width: "6%",
            render: (value, record, index) => {
                return record.chatLuong == 0 ? "Sai sót" : "Tốt";
            }
        },
        {
            title: "Tiến độ thực hiện (Trước/Đúng/Trễ)",
            key: "tienDo",
            dataIndex: "tienDo",
            className: "text-center",
            width: "7%",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            render: (value, record, index) => {
                return layTenTienDoKPI(record.tienDo)
            }
        },
        {
            title: "Chấm điểm (điểm trừ, điểm cộng)",
            key: "",
            dataIndex: "",
            className: "text-center",
            colSpan: 3,
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            children: [
                {
                    title: "Cá nhân",
                    key: "diemCaNhan",
                    dataIndex: "diemCaNhan",
                    className: "text-center",
                    width: "6%",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        if (source.id != idNhomKPI.diemCong && ((trangThai <= trangThaiKPI.lanhDaoPhongTuChoi && idNhanVien == user.idNhanVien)
                            || (user.isLanhDaoPhong && idNhanVien == user.idNhanVien && trangThai <= trangThaiKPI.lanhDaoPhuTrachTuChoi))) {
                          return (
                                <InputNumber
                                    style={{ width: "100%" }}
                                    value={record.diemCaNhan === 0 ? '' : record.diemCaNhan}
                                    onChange={(e: any) => {
                                        if (e == null) {
                                            record.diemCaNhan = 0
                                            source.chiTiet[index].diemCaNhan = 0
                                        }
                                        else {
                                            record.diemCaNhan = e;
                                            source.chiTiet[index].diemCaNhan = e
                                        }
                                        var diem = source.diemChuan + (source.chiTiet || []).reduce((tong, x) => tong + (x.diemCaNhan || 0), 0);
                                        source.tuDanhGia = diem < 0 ? 0 : diem;
                                        onChange(source, showError);
                                    }}
                                    className="hide-arrow"
                                />
                            );
                        }
                        else {
                            return record.diemCaNhan == 0 ? "" : record.diemCaNhan;
                        }
                    }
                },
                {
                    title: "LĐ phòng",
                    key: "diemLanhDaoPhong",
                    dataIndex: "diemLanhDaoPhong",
                    className: "text-center",
                    width: "6%",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        if (((trangThai >= trangThaiKPI.trinhLanhDaoPhong
                            && trangThai <= trangThaiKPI.lanhDaoPhuTrachTuChoi && user.isLanhDaoPhong && hasLDPhuTrach) || (trangThai >= trangThaiKPI.trinhLanhDaoPhong && trangThai <= trangThaiKPI.lanhDaoDonViTuChoi && !hasLDPhuTrach))) {
                           return (
                                <InputNumber
                                    style={{ width: "100%" }}
                                    value={record.diemLanhDaoPhong === 0 ? '' : record.diemLanhDaoPhong}
                                   onChange={(e: any) => {

                                       let value = e;

                                       if (value == null) {
                                           value = 0;
                                       }
                                       if (source.id == idNhomKPI.diemCong && value !== 0) {
                                           value = Math.min(5, Math.max(1, value));
                                       }

                                       record.diemLanhDaoPhong = value;
                                       source.chiTiet[index].diemLanhDaoPhong = value;
                                        var diem = source.diemChuan + (source.chiTiet || []).reduce((tong, x) => tong + (x.diemLanhDaoPhong || 0), 0);
                                        source.lanhDaoPhong = diem < 0 ? 0 : diem;
                                        onChange(source, showError);
                                    }}
                                    className="hide-arrow"
                                />
                            );
                        }
                        else {
                            return record.diemLanhDaoPhong == 0 ? "" : record.diemLanhDaoPhong;
                        }
                    }
                },
                {
                    title: "LĐ phụ trách",
                    key: "diemLanhDaoPhuTrach",
                    dataIndex: "diemLanhDaoPhuTrach",
                    className: "text-center",
                    width: "6%",
                    onCell: (_, index) => ({
                        colSpan: _.isTieuDe === 1 ? 0 : 1,
                    }),
                    render: (value, record, index) => {
                        if (
                            (trangThai >= trangThaiKPI.trinhLanhDaoPhuTrach && trangThai <= trangThaiKPI.lanhDaoDonViTuChoi && menu[Links.KPI.LanhDaoPhuTrachDuyet])) {
                            return (
                                <InputNumber
                                    style={{ width: "100%" }}
                                    value={(record.diemLanhDaoPhuTrach === 0) ? '' : record.diemLanhDaoPhuTrach}
                                    onChange={(e: any) => {
                                        let value = e;

                                        if (value == null) {
                                            value = 0;
                                        }
                                        if (source.id == idNhomKPI.diemCong && value !== 0) {
                                            value = Math.min(5, Math.max(1, value));
                                        }
                                        record.diemLanhDaoPhuTrach = value;
                                        source.chiTiet[index].diemLanhDaoPhuTrach = value;
                                        var diem = source.diemChuan + (source.chiTiet || []).reduce((tong, x) => tong + (x.diemLanhDaoPhuTrach || 0), 0);
                                        source.lanhDaoPhuTrach = diem < 0 ? 0 : diem;
                                        onChange(source, showError);
                                    }}
                                    className="hide-arrow"
                                />
                            );
                        }
                        else {
                            return record.diemLanhDaoPhuTrach == 0 ? "" : record.diemLanhDaoPhuTrach;
                        }
                    }
                },
            ]
        },
        {
            title: "Ghi chú",
            key: "ghiChu",
            dataIndex: "ghiChu",
            onCell: (_, index) => ({
                colSpan: _.isTieuDe === 1 ? 0 : 1,
            }),
            width: "15%",
            render: (value, record, index) => {
                return record.ghiChu;
            }
        },
        ...dynamicColumns
    ];

    const eventCopyChiTietKPI = async () => {
        dispatch(showLoadingScreen());
        try {
            if (listIdCopy.length > 0) {
                await saoChepChiTietKPI(listIdCopy);
                toast.success("Sao chép nội dung KPI cá nhân thành công");
                setListIdCopy([]);
            } else {
                toast.error("Vui lòng chọn nội dung cần sao chép");
            }
        } catch (error: any) {
            toast.error(error);
        };

        dispatch(hideLoadingScreen());
    }
    useEffect(() => {
        dispatch(showLoadingScreen());
        if (source.id == idNhomKPI.chuyenMon) {
            var listId = source.chiTiet?.map(x => x.id);
            setListIdCopy(listId);
        }
        if ((source.chiTiet || []).some(record => !(record.diemLanhDaoPhuTrach == 0 || record.diemLanhDaoPhuTrach == null))
            && menu[Links.KPI.TongHopKPI] && trangThai == trangThaiKPI.pheDuyet) {
            var dsViPham = source.chiTiet.filter((item) => {
                return (item.diemLanhDaoPhuTrach != null && item.diemLanhDaoPhuTrach < 0) || (item.diemLanhDaoPhong != null && item.diemLanhDaoPhong < 0 && !hasLDPhuTrach);
            }).map(function (item) {
                return item.id;
            });
        }
        dispatch(hideLoadingScreen());
    }, [])

    return (
        <Tabs
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: tieuDe,
                    children:
                        <div className="card">
                            <Row>
                                <Col span="24">
                                    <Table
                                        locale={{ emptyText: "Không có dữ liệu" }}
                                        dataSource={(source.chiTiet || []).map((x: ChiTietKPICaNhan, idx: number) => { x.key = idx; return x; })}
                                        columns={tableColumns}
                                        pagination={false}
                                    >
                                    </Table>
                                </Col>
                            </Row>
                            {
                                source.id == idNhomKPI.diemCong && (source.dsTaiLieu?.length ?? 0)  > 0 &&
                                <Row className="m-2" gutter={24}>
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                            <PaperClipOutlined style={{ color: '#64748b', fontSize: '18px' }} />
                                            <label style={{ fontWeight: 600, color: '#334155', fontSize: '14px', margin: 0, marginRight: '4px' }}>
                                                File đính kèm:
                                            </label>

                                            {source?.dsTaiLieu.map((value: any, index: number) => (
                                                <div
                                                    key={index}
                                                    onClick={() => window.open(urlAdmin + value?.duongDan?.replace(/\\/g, "/"), '_blank')}
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        padding: '4px 10px',
                                                        backgroundColor: '#e0f2fe',
                                                        border: '1px solid #bae6fd',
                                                        color: '#0369a1',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s',
                                                        fontWeight: 500
                                                    }}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#bae6fd'}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0f2fe'}
                                                >
                                                    {value.tenTep}
                                                </div>
                                            ))}
                                        </div>
                                </Row>
                            }
                            {
                                source.id != idNhomKPI.diemCong &&
                                <Row className="m-2" gutter={24}>
                                    <Col span="8">
                                        <Form.Item
                                            label="Tự đánh giá"
                                        >
                                            {source?.tuDanhGia}
                                        </Form.Item>
                                    </Col>
                                    {
                                        trangThai >= trangThaiKPI.trinhLanhDaoPhong &&
                                        <Col span="8">
                                            <Form.Item
                                                label="Lãnh đạo phòng"
                                            >
                                                {
                                                    ((trangThai == trangThaiKPI.trinhLanhDaoPhong || trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi)
                                                        || (trangThai == trangThaiKPI.lanhDaoDonViTuChoi && !hasLDPhuTrach))
                                                        && disabled && menu[Links.KPI.LanhDaoPhongDuyet]
                                                        ? <InputNumber
                                                            disabled={true}
                                                            style={{ width: "100%" }}
                                                            value={source?.lanhDaoPhong}
                                                            onChange={(value: any) => {
                                                                source.lanhDaoPhong = value;
                                                                onChange(source, showError);
                                                            }}
                                                            className="hide-arrow"
                                                        />
                                                        : trangThai != trangThaiKPI.trinhLanhDaoPhong
                                                            ? source?.lanhDaoPhong > 0
                                                                ? source?.lanhDaoPhong
                                                                : ""
                                                            : ""
                                                }
                                            </Form.Item>
                                        </Col>
                                    }
                                    {
                                        trangThai >= trangThaiKPI.trinhLanhDaoPhuTrach &&
                                        <Col span="8">
                                            <Form.Item
                                                label="Lãnh đạo phụ trách"
                                            >
                                                {
                                                    (trangThai == trangThaiKPI.trinhLanhDaoPhuTrach || trangThai == trangThaiKPI.lanhDaoDonViTuChoi)
                                                        && disabled && menu[Links.KPI.LanhDaoPhuTrachDuyet]
                                                        ? <InputNumber
                                                            disabled={true}
                                                            style={{ width: "100%" }}
                                                            value={source?.lanhDaoPhuTrach}
                                                            className="hide-arrow"
                                                            onChange={(value: any) => {
                                                                source.lanhDaoPhuTrach = value;
                                                                onChange(source, showError);
                                                            }}
                                                        />
                                                        : trangThai != trangThaiKPI.trinhLanhDaoPhuTrach
                                                            ? source?.lanhDaoPhuTrach > 0
                                                                ? source?.lanhDaoPhuTrach
                                                                : ""
                                                            : ""
                                                }
                                            </Form.Item>
                                        </Col>
                                    }
                                </Row>
                            }
                        </div>
                }
            ]}
        />
    );
};

export default ViewChiTietKPITab;
